import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { customStyles } from "./index.styles";

interface CTASectionProps {
  title?: string;
  description?: string;
  contactButtonText?: string;
}

const CTASection = ({
  title = "Interested in this service?",
  description = "Contact us today to get a free quote and learn more about how we can help you.",
  contactButtonText = "Contact Us",
}: CTASectionProps) => {
  const navigate = useNavigate();

  return (
    <Box sx={customStyles.ctaSection}>
      <Typography variant="h5" sx={customStyles.ctaTitle}>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={customStyles.ctaText}>
        {description}
      </Typography>
      <Box sx={customStyles.buttonGroup}>
        <Button
          variant="contained"
          size="large"
          sx={customStyles.callButton}
          onClick={() => navigate("/contact")}
          startIcon={<SupportAgentIcon />}
        >
          {contactButtonText}
        </Button>
      </Box>
    </Box>
  );
};

export default CTASection;
